import PropTypes from "prop-types";

import classNames from "classnames";

import Icon from "assets/svg/long-down.svg";

import styles from "./styles.module.css";

const PriceTrend = ({ data, noScroll = false }) => {
  const handleClick = () => {
    const targetElement = document.getElementById("fiyat-analizi");

    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - 100 /* 100 => sticky header size */,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const wrapperClasses = classNames({
    [styles.wrapper]: true,
    [styles.noScroll]: noScroll,
    [styles.scroll]: !noScroll,
  });

  return (
    <div className={wrapperClasses} onClick={noScroll ? undefined : handleClick}>
      {`%${data}`}
      <span className={styles.iconWrap}>
        <Icon />
      </span>
    </div>
  );
};

PriceTrend.propTypes = {
  data: PropTypes.number,
  noScroll: PropTypes.bool,
};

export default PriceTrend;
